
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class FranchiseeProductsGrid extends Serenity.EntityGrid<FranchiseeProductsRow, any> {
        protected getColumnsKey() { return FranchiseeProductsColumns.columnsKey; }
        protected getDialogType() { return FranchiseeProductsDialog; }
        protected getIdProperty() { return FranchiseeProductsRow.idProperty; }
        protected getInsertPermission() { return FranchiseeProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return FranchiseeProductsRow.localTextPrefix; }
        protected getService() { return FranchiseeProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions?.();

            const editItem = this.editItem.bind(this);

            // Card view setup
            const cardView = new Serenity.CardViewMixin<FranchiseeProductsRow>({
                grid: this,
                renderItem: (item, index) => React.createElement(FranchiseeProductCard, {
                    item: item,
                    editItem: editItem
                })
            });

            // Show card view by default
            setTimeout(() => {
                cardView.switchView('card'); // 'true' enables card view
            }, 200);

            // Create button and append to toolbar
            const $goToCartBtn = $('<button class="go-to-cart-btn">🛒 Go To Cart</button>')
                .appendTo(this.toolbar.element)
                .click(() => {
                    CartService.RetrieveFranchiseeCart({
                        EntityId: 1
                    }, response => {
                        if (response.Entity == null) {
                            Q.notifyError("No Data found in cart");
                            
                        } else {
                            let dlg = new CartDialog();
                            dlg.loadByIdAndOpenDialog(response.Entity.Id);
                        }
                    });
                });

            // 🔢 Get product count and update button text
            CartService.RetrieveFranchiseeCart({
                EntityId: 1
            }, response => {
                if (response.Entity != null && response.Entity.CartProducts?.length > 0) {
                    const count = response.Entity.CartProducts.length;
                    $goToCartBtn.text(`🛒 Go To Cart (${count})`);
                   
                }
               
            });
        }

    }
}